import { render } from "./Column.vue?vue&type=template&id=917a33e4"
import script from "./Column.vue?vue&type=script&lang=ts"
export * from "./Column.vue?vue&type=script&lang=ts"

import "./Column.vue?vue&type=style&index=0&id=917a33e4&lang=scss"
script.render = render

export default script